/**
 *  API response model
 * {
 *   "success": false,
 *   "status": "Error",
 *   "data": null,
 *   "responseMessage": "Failed to get details in SAP.",
 *   "errors": null
 * }
 */

/**
 * status
 * Unconfirmed - Show the pop-up for user to confirm dispatch date and delivery address.
 * Processing - Don't show the pop-up. Dispatch date can't be updated. Address can still be updated.
 * Order Confirmed - Dispatch date and address can't be updated. But can update Address for future order.
 */

import { LOGOUT_URL, scheduleGlobal401Logout } from './authSession.js'

const unauthorizedPayload = {
  success: false,
  status: 'Unauthorized',
  data: null,
  responseMessage: 'Unauthorized',
  errors: null
}

export const fetcher = (url, { arg }) => {
  const fetchData = async () => {
    if (!url) throw new Error('URL not provided')

    if (!arg?.method) throw new Error('Method not provided')

    const { skipGlobal401Handling, ...rest } = arg
    const fetchOptions = {
      ...rest,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...rest.headers
      }
    }

    const response = await fetch(url, fetchOptions)

    const data = await response.json()

    if (response.status === 401) {
      const isLogoutRequest = url === LOGOUT_URL || url.endsWith(LOGOUT_URL)
      if (isLogoutRequest) {
        /* eslint-disable prefer-promise-reject-errors */
        return Promise.reject(unauthorizedPayload)
        /* eslint-enable prefer-promise-reject-errors */
      }
      if (skipGlobal401Handling) {
        /* eslint-disable prefer-promise-reject-errors */
        return Promise.reject(unauthorizedPayload)
        /* eslint-enable prefer-promise-reject-errors */
      }
      scheduleGlobal401Logout()
      /* eslint-disable prefer-promise-reject-errors */
      return Promise.reject(unauthorizedPayload)
      /* eslint-enable prefer-promise-reject-errors */
    }
    if (!response.ok) {
      if (data.title) { data.responseMessage = data.title }
      return Promise.reject(data)
    }

    return Promise.resolve(data)
  }

  return fetchData()
}
